exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".switch-button label{display:block;width:41px;height:18px;margin:0px auto;border-radius:100px;transition:all 0.2s ease-in-out;-webkit-transition:all 0.2s ease-in-out;background-color:#E6E9EC}.switch-button input{display:none}.switch-button i{height:16px;width:16px;background:#ffffff;display:inline-block;border-radius:100px;margin-top:1px;margin-left:2px;transition:all 0.2s ease-in-out;-webkit-transition:all 0.2s ease-in-out;pointer-events:none;box-shadow:0px 0px 0px 0px rgba(0,0,0,0)}.switch-button label:hover>i{box-shadow:0px 1px 2px 0px rgba(0,0,0,0.2);transform:scale(1.01)}.switch-button input:checked+label>i{margin-left:24px}.switch-button label:active{background-color:#A6B9CB}.switch-button label:active>i{width:34px;box-shadow:0px 2px 4px 0px rgba(0,0,0,0.2)}.switch-button input:checked+label:active>i{margin-left:18px}.switch-button input:checked+label{background-color:#2ecc71}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/switch-button/style.scss
// module id = 1821
// module chunks = 35